//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ["keyValue", "showDialog"],
  data: function data() {
    return {
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.childData = this.keyValue;
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", false);
    }
  }
};